import { Button, Header, Grid, Message, Icon } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { ErrorMessage, Formik, Form } from 'formik';
import { observer } from 'mobx-react-lite';
import MyTextInput from '../../app/common/form/MyTextInput';
import ValidationErrors from '../errors/ValidationErrors';
import { ForgotPasswordFormValidationSchema } from '../../app/common/form/FormikFormValidations';
import { ForgotPasswordFormValues } from '../../app/models/user';

export default observer(function ForgotPasswordForm() {
    const {userStore, modalStore} = useStore();
    const { forgotPassword } = userStore;

    return (
        <Formik
            initialValues={new ForgotPasswordFormValues()}
            onSubmit={(values, {setErrors}) => forgotPassword(values).catch(error => 
                setErrors({error})).finally(() => modalStore.closeModal())}
            validationSchema={ForgotPasswordFormValidationSchema}
        >
            {({handleSubmit, isSubmitting, errors, dirty, isValid}) => (
                <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Header as='h1' className='text-center' content='Forgot Password' />

                                <Message icon>
                                    <Icon name='bell' />
                                    <Message.Content>
                                        {/* Please enter your e-mail address below and we'll send a link to reset your password. */}
                                        Enter your email address below and your password will be emailed to you.
                                    </Message.Content>
                                </Message>
                                <MyTextInput name='subscriberEmail' placeholder='Email' />
                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row>
                            <Grid.Column width={16}>
                            <ErrorMessage 
                                name='error' render={() => 
                                <ValidationErrors errors={errors.error}/>}
                            />
                            <Button 
                                disabled={!dirty && !isValid}
                                loading={isSubmitting} 
                                color='teal' 
                                content={'Submit Password Request'}
                                fluid 
                                type='submit'
                            />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
            )}
        </Formik>
    )
})